export const emailVerification = (text) => {
  const email =
    text?.charAt(0) + '******' + text?.substr(text?.indexOf('@') - 1);
  return email;
};
